function prevent(event) {
  event.preventDefault()
  return event
}

export default prevent
